import { css } from 'emotion';
import { observer } from 'mobx-react';
import * as React from 'react';
import Slider from 'react-slick';

import arrowLeft from '../assets/tab/arrow-left.svg';
import arrowRight from '../assets/tab/arrow-right.svg';

import { Tab } from './Tab';

import { BREAKPOINT_SMALL } from '../consts/breakpoints';
import { carouselContainer } from '../styles/carouselContainer';

// #region Style
const wrapper = css`
  background-color: #f6f2f3;
  padding: 0 100px 0 100px;
  height: 60px;
`;

const containerModifications = css`
  .slick-next {
    position: absolute;
    right: -35px;
    top: 30%;
    z-index: 1;
    @media (min-width: ${BREAKPOINT_SMALL}) {
      right: -35px;
      top: 30%;
    }
  }

  .slick-prev {
    position: absolute;
    left: -35px;
    top: 30%;
    z-index: 1;
    @media (min-width: ${BREAKPOINT_SMALL}) {
      left: -35px;
      top: 30%;
    }
  }

  .slick-disabled {
    display: none !important;
  }

  .slick-slide {
    position: relative;
    :first-of-type {
      ::before {
        position: absolute;
        content: ' ';
        bottom: 4px;
        left: 0;
        height: 48px;
        border: 2px solid #b7acd4;
        border-width: 0 0 0 2px;
      }
    }
    :last-of-type {
      ::before {
        position: absolute;
        content: ' ';
        bottom: 4px;
        right: 0;
        height: 48px;
        border: 2px solid #b7acd4;
        border-width: 0 2px 0 0;
      }
    }
  }
`;
// #endregion

const Arrow = (props: any) => {
  const { className, onClick, arrowDirection } = props;
  const arrowImage = arrowDirection === 'left' ? arrowLeft : arrowRight;

  const borderLeftArrow = arrowDirection === 'left' ? '-11px' : 0;
  const borderRightArrow = arrowDirection === 'right' ? '-11px' : 0;

  const borderWidthLeft = arrowDirection === 'left' ? '2px' : 0;
  const borderWidthRight = arrowDirection === 'right' ? '2px' : 0;

  const stl = css`
    background: url(${arrowImage});
    cursor: pointer;
    display: block;
    height: 25px;
    width: 25px;
    :before {
      position: absolute;
      content: ' ';
      bottom: -13px;
      left: ${borderRightArrow};
      right: ${borderLeftArrow};
      height: 48px;
      border: 2px solid #b7acd4;
      border-width: ${`0 ${borderWidthLeft} 0 ${borderWidthRight}`};
    }
  `;

  return <div className={`${className} ${stl}`} onClick={onClick} role="region" />;
};

const ArrowWrapper = ({ children, ...props }: any) => <div {...props}>{children}</div>;

export interface ITab {
  isCompleted: boolean;
  isBeforeSelected?: boolean;
  isAfterSelected?: boolean;
  type?: string | number;
  id: number | string;
  name: string;
  title: string;
  isSelected: boolean;
  isMoreMagic?: boolean;
}

interface ITabContainerDesktopProps {
  tabs: Array<ITab>;
  onSelectedTab?(value?: number | string): void;
}

@observer
export class TabContainerDesktop extends React.Component<ITabContainerDesktopProps> {
  public render() {
    const { tabs, onSelectedTab } = this.props;

    const responsiveBreakpoints = [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1040,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6,
        },
      },
    ];

    return (
      <div className={wrapper}>
        <div className={`${carouselContainer} ${containerModifications}`}>
          <Slider
            arrows
            infinite={false}
            nextArrow={
              <ArrowWrapper>
                <Arrow arrowDirection={'right'} />
              </ArrowWrapper>
            }
            prevArrow={
              <ArrowWrapper>
                <Arrow arrowDirection={'left'} />
              </ArrowWrapper>
            }
            responsive={responsiveBreakpoints}
            slidesToScroll={1}
            slidesToShow={7}
            speed={500}
          >
            {tabs.map(({ isCompleted, isAfterSelected, isBeforeSelected, id, name, title, isSelected, type }) => (
              <Tab
                key={id}
                isCompleted={isCompleted}
                isBeforeSelected={isBeforeSelected}
                isAfterSelected={isAfterSelected}
                isSelected={isSelected}
                id={id}
                name={name}
                title={title}
                onClick={onSelectedTab}
                type={type}
              />
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}
